import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { Redirect, useLocation } from 'react-router-dom';

import { useSelector } from "react-redux";
import { useGetUser } from "../hooks/useOfProfile"
import {useGetAllClientConnectionsPerMonth, useGetAllClientUserCount, useGetAllClientRoleCount} from '../hooks/useOfCharts'

import { Container, Card, Row, Col} from "react-bootstrap"

import ProfileHeader from "../components/Profile/ProfileHeader";

import ChartAccessesPerDayStackAllClients from "../components/Charts/AccessesPerDayStackAllClients"
import ChartAccessesPerMonthTotalPaiAllClients from "../components/Charts/AccessesPerMonthTotalPaiAllClients"
import ChartAccessesPerMonthAllClients from "../components/Charts/AccessesPerMonthAllClients"
import ChartTotalUsersPerClient from "../components/Charts/TotalUsersPerClient"
import ChartTotalUsersPerRole from "../components/Charts/TotalUsersPerRole"
import { Dropdown } from "@fluentui/react";
import { useGetAllClient } from "../hooks/useOfClient";
import AuthVerify from "../components/AuthVerify";
import CardHeader from "react-bootstrap/esm/CardHeader";
import SAdminProfileOptionButtons from "../components/Controls/Buttons/SAdminProfileOptionButtons";
import chartService from "../services/chart.service";


const ProfileSAdmin = (props) => {
  const { t } = useTranslation(); 
  
  const { user: currentAuth } = useSelector((state) => state.auth);

  const location = useLocation();

  const [user, setUser] = useState(null);
  useGetUser(location.state ? location.state : currentAuth.userName, setUser);

  const [selectedFilterClientId, setSelectedFilterClientId] = useState(-1);
  const [clientList, setClientList] = useState(null);        
  useGetAllClient(clientList, setClientList);

  const [chartDataAccessPerMonth, setChartDataAccessPerMonth] = useState(null);        
  useGetAllClientConnectionsPerMonth(chartDataAccessPerMonth, setChartDataAccessPerMonth);

  const [chartDataClientUsers, setChartDataClientUsers] = useState(null);        
  useGetAllClientUserCount(chartDataClientUsers, setChartDataClientUsers);

  const [chartDataClientRoles, setChartDataClientRoles] = useState(null);        
  useGetAllClientRoleCount(chartDataClientRoles, setChartDataClientRoles, selectedFilterClientId);

    const saveByteArray = (reportName, byte) => {
      let blob = new Blob([byte], {type: "application/octet-stream"});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      let fileName = reportName;
      link.download = fileName;
      link.click();
      link.remove();
  };

  const base64ToArrayBuffer = (base64) => {
      let binaryString = window.atob(base64);
      let binaryLen = binaryString.length;
      let bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
  }

  const onUserStatusReportClick = () => {
    chartService.getUsersStatus().then((response) => {
      if (response.data.succeeded) {
        saveByteArray(`${t('data-lang-btn-userstatus')}.xlsx`, base64ToArrayBuffer(response.data.data));
      }
      else {
      }
    }).catch((ex) => {
    });
  }

  const onUserConnectionReportClick = () => {
    chartService.getUserConnections().then((response) => {
      if (response.data.succeeded) {
        saveByteArray(`${t('data-lang-btn-userconnections')}.xlsx`, base64ToArrayBuffer(response.data.data));
      }
      else {
      }
    }).catch((ex) => {
    });
  }

  const onClientFilterChange = (ev, item) => {
    setSelectedFilterClientId(item.key)
    setChartDataClientRoles(null)
  }

  const onLoadClientFilter = () => {
    let array = []
    array.push({ key: -1, text: t('data-lang-placeholder-selectoption'), title: t('data-lang-placeholder-selectoption') })
    
    if (clientList) {
      clientList.map(x => array.push({ key: x.id, text: x.name, title: x.name }))
    }

    return array
};

  return (
    <>
      <AuthVerify currentToken={currentAuth} />
      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          <ProfileHeader user={ user } showEditProfile={true} />
        </Col>
      </Row>     
      <Row className="justify-content-center">

      </Row>
      <Row>
        <Col md={12} lg={12} xl={12}>
          <Card style={{minHeight:"350px"}} className="rounded-3">
            <CardHeader>
              <Card.Title className="d-flex">
                <h4>{t('data-lang-boxname-chart-accesspermonth')}</h4>
                <SAdminProfileOptionButtons items={ [
                  {
                    text: t('data-lang-btn-userstatus'),
                    iconName: 'UserOptional',
                    key: 'userstatus',
                    show: true,
                    onClick: onUserStatusReportClick
                  },
                  {
                    text: t('data-lang-btn-userconnections'),
                    iconName: 'UserGauge',
                    key: 'userconnections',
                    show: true,
                    onClick: onUserConnectionReportClick
                  }
                ] } />
            </Card.Title>
            </CardHeader>
            <Card.Body className="col-xs-12">
              <Row>
                <Col lg={12} xl={5}>
                  <Container>
                      <ChartAccessesPerMonthTotalPaiAllClients chartData={chartDataAccessPerMonth} />
                  </Container>
                </Col>
                <Col lg={12} xl={7}>
                  <Container>    
                      <ChartAccessesPerMonthAllClients chartData={chartDataAccessPerMonth} />
                    </Container>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col md={12} lg={12} xl={12}>
          <Card style={{height:"350px"}} className="rounded-3">
            <Card.Body className="col-xs-12">
              <Row>
                <Col xl={12}>
                  <h4 style={{borderBottom: "2px solid #b1b1b1"}}>{t('data-lang-boxname-chart-accessperdaylastmonth')}</h4>
                  <ChartAccessesPerDayStackAllClients />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col xl={12}>
          <Row>
            <Col xl={6}>
              <Card style={{height:"350px"}} className="rounded-3">
                <Card.Body className="col-xs-12">
                    <Row>
                      <Col xl={12}>
                        <h4 style={{borderBottom: "2px solid #b1b1b1"}}>{t('data-lang-boxname-chart-totaluserperclient')}</h4>
                        <ChartTotalUsersPerClient chartData={chartDataClientUsers} />
                      </Col>
                    </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col xl={6}>
              <Card style={{height:"350px"}} className="rounded-3">
                <Card.Body className="col-xs-12">
                    <Row>
                      <Col xl={12}>
                        <h4 style={{borderBottom: "2px solid #b1b1b1"}}>{t('data-lang-boxname-chart-totalroleperclient')}</h4>
                        {
                            clientList &&
                            <div className="d-flex pe-2 ps-2 pt-1">
                                <label>{t('data-lang-lbl-section')}</label>
                                <Dropdown
                                    placeholder={t('data-lang-placeholder-selectoption')}
                                    options={onLoadClientFilter()}
                                    selectedKey={selectedFilterClientId}
                                    onChange={onClientFilterChange}
                                    styles={ {title: { height: "27px" }} }
                                    className="pt-1 pe-2"
                                />
                            </div>
                        }
                        <ChartTotalUsersPerRole chartData={chartDataClientRoles} />
                      </Col>
                    </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>    
    </>
  );
};

export default ProfileSAdmin;
